<app-modal title="Shareholder SSN" [showFooter]="false">
  <div class="mb-4 font-weight-bold">
    Enter last 4 digits of SSN/ID# for {{employee.displayName}}
  </div>

  <form [formGroup]="pinForm"
        (ngSubmit)="createShareholder()"
        class="m-4"
        autocomplete="off"
        novalidate>

    <div class="row">

      <div class="col-sm-6">

        <div class="form-group"
             [class.error]="pin.invalid && (pin.dirty || pin.touched || mouseoverCreateShareholder)">
          <span class="fake-label">Last 4 SSN</span>
          @if (pin.invalid && (pin.dirty || pin.touched || mouseoverCreateShareholder)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="pin"
                 app-autofocus
                 type="text"
                 mask="9990"
                 name="pin"
                 class="form-control" />
        </div>

      </div>

      <div class="col-sm-6 col-button">

        <span (mouseenter)="mouseoverCreateShareholder=true" (mouseleave)="mouseoverCreateShareholder=false">
          <app-button [buttonConfig]="{textChange: ['Add']}"
                      [isLoading]="isSubmitting"
                      [disabled]="!pinForm.valid || isSubmitting"
                      (textBtnClickEmt)="createShareholder()"></app-button>
        </span>

      </div>

    </div>

  </form>
</app-modal>
